import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconEyeProps extends SVGProps<any> {}
export class SVGIconEye extends Component<SVGIconEyeProps> {
  render() {
    const { width = 40, height = 31.5, fill = '#513389', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-filter-price-eye-fifty"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 40 31.5`}
        fill={fill}
        {...rest}
      >
        <g clipPath="url(#clip0_1300_67)" fill={fill}>
          <path
            d="M37.572 13.4701C36.1925 10.3439 30.7833 0.149414 19.0003 0.149414C7.21722 0.149414 1.80801 10.3439 0.428603 13.4701C0.243434 13.889 0.147583 14.3444 0.147583 14.8053C0.147583 15.2661 0.243434 15.7215 0.428603 16.1404C1.80801 19.2634 7.21722 29.4578 19.0003 29.4578C30.7833 29.4578 36.1925 19.2634 37.572 16.1372C37.7568 15.7187 37.8524 15.2639 37.8524 14.8036C37.8524 14.3434 37.7568 13.8886 37.572 13.4701ZM19.0003 26.2013C9.09153 26.2013 4.46784 17.4642 3.28953 14.8216C4.46784 12.1431 9.09153 3.40591 19.0003 3.40591C28.8855 3.40591 33.5108 12.1056 34.7111 14.8036C33.5108 17.5016 28.8855 26.2013 19.0003 26.2013Z"
            fill={fill}
          />
          <path
            d="M19.0003 6.6626C17.4466 6.6626 15.9279 7.14007 14.6361 8.03463C13.3442 8.92921 12.3374 10.2007 11.7429 11.6883C11.1483 13.1759 10.9927 14.8129 11.2959 16.3921C11.5989 17.9714 12.3471 19.422 13.4457 20.5605C14.5443 21.6991 15.944 22.4745 17.4678 22.7886C18.9916 23.1027 20.571 22.9415 22.0064 22.3253C23.4418 21.7092 24.6686 20.6657 25.5318 19.3268C26.3949 17.988 26.8556 16.414 26.8556 14.8038C26.8531 12.6454 26.0247 10.5762 24.5521 9.04995C23.0795 7.52375 21.0829 6.66518 19.0003 6.6626ZM19.0003 19.6885C18.068 19.6885 17.1569 19.4021 16.3817 18.8654C15.6067 18.3286 15.0025 17.5657 14.6458 16.6731C14.2891 15.7806 14.1957 14.7984 14.3776 13.8509C14.5595 12.9033 15.0083 12.0329 15.6675 11.3498C16.3267 10.6666 17.1665 10.2014 18.0807 10.0129C18.995 9.82446 19.9427 9.92121 20.804 10.2909C21.6652 10.6606 22.4013 11.2867 22.9192 12.09C23.437 12.8933 23.7135 13.8377 23.7135 14.8038C23.7135 16.0993 23.2169 17.3418 22.333 18.2579C21.4492 19.1739 20.2503 19.6885 19.0003 19.6885Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_1300_67" fill={fill}>
            <rect width="38" height="36" fill={fill} />
          </clipPath>
        </defs>
      </SVG>
    );
  }
}
